const USER_STORAGE_KEY = "user";
const USER_UPDATED_EVENT = "learnova:user-updated";
const USER_PERSISTENCE_KEY = "learnova_user_persistence";

export function getStoredUser() {
  try {
    const rawUser = window.localStorage.getItem(USER_STORAGE_KEY) || window.sessionStorage.getItem(USER_STORAGE_KEY);
    return rawUser ? JSON.parse(rawUser) : null;
  } catch (error) {
    window.localStorage.removeItem(USER_STORAGE_KEY);
    window.sessionStorage.removeItem(USER_STORAGE_KEY);
    return null;
  }
}

export function setStoredUser(user, options = {}) {
  const remember = options.remember !== false;
  const storage = remember ? window.localStorage : window.sessionStorage;
  const otherStorage = remember ? window.sessionStorage : window.localStorage;

  window.localStorage.setItem(USER_PERSISTENCE_KEY, remember ? "local" : "session");
  otherStorage.removeItem(USER_STORAGE_KEY);
  storage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
  window.dispatchEvent(new CustomEvent(USER_UPDATED_EVENT, { detail: user }));
}

export function updateStoredUser(patch) {
  const currentUser = getStoredUser();
  if (!currentUser) {
    return;
  }

  const remember = window.localStorage.getItem(USER_PERSISTENCE_KEY) !== "session";

  setStoredUser({
    ...currentUser,
    ...patch
  }, { remember });
}

export function clearStoredUser() {
  window.localStorage.removeItem(USER_STORAGE_KEY);
  window.sessionStorage.removeItem(USER_STORAGE_KEY);
  window.localStorage.removeItem(USER_PERSISTENCE_KEY);
  window.dispatchEvent(new CustomEvent(USER_UPDATED_EVENT, { detail: null }));
}

export function isAllowedRole(user, roles = []) {
  if (!user) {
    return false;
  }

  if (!roles.length) {
    return true;
  }

  return roles.includes(user.role);
}

export function onStoredUserChange(listener) {
  window.addEventListener(USER_UPDATED_EVENT, listener);
  return () => window.removeEventListener(USER_UPDATED_EVENT, listener);
}
